import React from "react";

import type { SideMenuItemProps } from "../types.d";

const defaultAnchorClasses = [
  "block",
  "no-underline",
  "py-md",
  "px-sm",
  "hover:text-neutral",
  "hover:bg-surface-action-menu-hover",
  "nt-focus",
  "focus:bg-surface-action-menu-hover",
  "focus:rounded-sm"
].join(" ");

export default function SideMenuItemLink({
  item, activeKey, onItemClick, linkProps, useHierarchicalNumbering, className
}: SideMenuItemProps) {
  const isActive = activeKey === item.link;

  return (
    <a
      {...linkProps}
      className={`${defaultAnchorClasses} ${className ?? ""} ${isActive ? "selected" : ""} ${useHierarchicalNumbering ? "flex gap-sm" : ""}`}
      href={item.link}
      onClick={(e) => onItemClick?.(item, e)}
    >
      { (useHierarchicalNumbering && item?.chapterNumber) && <span>{item.chapterNumber}</span> }
      <span>{item.title}</span>
    </a>
  );
}
